import type { ExpirationBounds } from "shared/model";

// Подгоняет длительность под min/max пары; 0 в лимите — граница не задана.
export const clampDuration = (sec: number, bounds: ExpirationBounds): number => {
  const { min_expiration_sec: min, max_expiration_sec: max } = bounds;
  const atLeastMin = min > 0 ? Math.max(sec, min) : sec;
  return max > 0 ? Math.min(atLeastMin, max) : atLeastMin;
};
